import {
  SIGNUP_TOKEN_REQUEST,
  SIGNUP_TOKEN_REQUEST_ERROR,
  SIGNUP_TOKEN_REQUEST_SUCCESS
} from './auth.type'

import ApiRest, { SetApiHeaderWithToken } from '@/api/api-rest'

import {
  registerLocalStorage,
  clearLocalStorage
} from '@/utilities/localstorage.helper'

const state = {
  accountActivationStatus: false,
  accountActivationMessage: ''
}

const getters = {
  accountActivationStatus: state => state.accountActivationStatus,
  accountActivationMessage: state => state.accountActivationMessage
}

const mutations = {
  [SIGNUP_TOKEN_REQUEST_SUCCESS] (state, data) {
    state.accountActivationStatus = data.status
    state.accountActivationMessage = data.message
  },
  [SIGNUP_TOKEN_REQUEST_ERROR] (state, data) {
    state.accountActivationStatus = data.status
    state.accountActivationMessage = data.message
  }
}

const actions = {
  [SIGNUP_TOKEN_REQUEST] (context, credentials) {
    if (credentials.token) {
      return new Promise((resolve, reject) => {
        ApiRest()
          .post(`/activate/${credentials.token}`, {
            password: credentials.password
          })
          .then(({ data }) => {
            registerLocalStorage(data)
            SetApiHeaderWithToken()

            context.commit(SIGNUP_TOKEN_REQUEST_SUCCESS, {
              status: true,
              message: data.message
            })
            resolve(data)
          })
          .catch(({ data }) => {
            clearLocalStorage()
            context.commit(SIGNUP_TOKEN_REQUEST_ERROR, {
              status: false,
              message: data ? data.message : data
            })
            reject(data ? data.message : data)
          })
      })
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/signup.module.js